export const CRYPTO_KEY = 'sh1p0-sh1p-m4n4g3m3nt-syst3m'
